import getGraphQlClient from '~graphql/getGraphQlClient';
import { onErrorShowMessage } from '~src/errors';
import { GET_FUNERAL_SERVICE_BY_ID } from '../queries/funeralServices';

export const fetchFuneralServiceById = async (id) => {
  try {
    const graphQlClient = await getGraphQlClient();

    const response = await graphQlClient.query({
      variables: { id },
      query: GET_FUNERAL_SERVICE_BY_ID,
    });
    return response.data.defunto;
  } catch (error) {
    onErrorShowMessage();
    console.error(error);
  }
};
